export default __webpack_public_path__ + "static/media/group-8391.cc2e0023.png";